import React from 'react';
import { SortableHandle } from 'react-sortable-hoc';
import { tokens } from '@everfi/design-system';
import { Layout } from '../../../core/components/Layout/component.js';
import { Icon } from '../../../core/components/Icon/component.js';

var DragHandle = function DragHandle(_ref) {
  var isSortable = _ref.isSortable;
  if (!isSortable) return null;
  var DragHandle = SortableHandle(function () {
    return /*#__PURE__*/React.createElement(Layout, {
      padding: tokens.SpacingMd,
      cursor: 'grab',
      "data-component-type": "presentation-card-drag-handle"
    }, /*#__PURE__*/React.createElement(Icon, {
      iconName: "grip-dots",
      prefix: "fas",
      size: "xl",
      color: tokens.ColorsGrey500
    }));
  });
  return /*#__PURE__*/React.createElement(DragHandle, null);
};

DragHandle.displayName = "DragHandle";
export { DragHandle };